var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1766",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,253)",
    d: "m0 0 5 1v1355l-2 1-16-8-23-13-25-14-15-9-27-16-13-8-19-11-24-15-9-8-1-450v-123l-1-6h-155l-1 45v406l-1 8-5-2-12-11-8-7-9-9-7-8-12-12-7-8-9-10-9-11-11-12-11-14-11-15-16-24-12-21-9-17-11-28-6-18-5-25-2-14-1-18v-757l7-3 141-26 17-3h8l1 361v79h157v-102l1-367 6-3 99-18 41-8z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1049,254)",
    d: "m0 0 13 1 125 23 73 13 134 25 46 8 101 19 10 2 2 2v765l-2 20-5 25-6 20-11 27-12 25-12 20-11 16-10 14-22 28-12 13-9 11-47 47-8 7-14 12-11 10-10 8-11 9-14 11-18 14-38 28-20 14-42 28-20 12-18 11-27 16-29 17-27 15-35 19h-3l-1-142v-529l2-7 3-1h146l21 1 1 1 1 133 1 228 5-2 11-9 13-11 11-9 10-10 8-7 32-32 7-8 9-10 21-27 12-19 10-19 5-14 2-13v-612l-8-3-42-8-30-5-64-12-45-8-52-10-84-14-5-2-1-17v-156z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.a850572781c2f87859a5a0d26396c853.svg";
export { ForwardRef as ReactComponent };